(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('ReportingAreaActivity', ReportingAreaActivity);

    ReportingAreaActivity.$inject = ['$resource'];

    function ReportingAreaActivity($resource) {
        return $resource('api/reporting-area-activity', {}, {
            'getFilters': {
                method: 'GET',
                isArray: false,
                url: '/api/reporting-area-activity/filters'
            },
            'get': {
                method: 'GET',
                isArray: false
            },
            'downloadJson': {
                method: 'GET',
                headers: {
                    accept: 'application/json'
                },
                responseType: 'arraybuffer',
                url: '/api/reporting-area-activity/download-json',
                transformResponse: function(data, headers) {
                    var filename = headers('FileName') || 'reporting-area-activity.json';
                    var contentType = headers('ContentType') || 'application/json';
                    var file = null;
                    if (data) {
                        file = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: file,
                        fileName: filename,
                        contentType: contentType
                    };
                }
            }
        });
    }
})();
